export default __webpack_public_path__ + "static/media/css.d8d8122b.png";